import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import logo from "assets/images/logos/logo-publique.png";

function BrandLogo({ width, sx }) {
  return (
    <Box
      component="img"
      src={logo}
      alt="Publique Sua Obra"
      width={1104}
      height={1425}
      sx={{
        display: "block",
        width,
        maxWidth: "100%",
        height: "auto",
        objectFit: "contain",
        backgroundColor: "#fff",
        borderRadius: "8px",
        ...sx,
      }}
    />
  );
}

BrandLogo.defaultProps = { width: 96, sx: {} };
BrandLogo.propTypes = { width: PropTypes.number, sx: PropTypes.object };

export default BrandLogo;
